import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { CampaignClass } from '@feathr/blackbox';
import { CampaignLabelMap } from '@feathr/blackbox';
import { ConfirmModal } from '@feathr/components';

export interface IMetaDeprecationModalProps {
  campaignType: CampaignClass.Facebook | CampaignClass.EmailListFacebook;
  onCancel: () => void;
  onConfirm: () => void;
  opened: boolean;
}

function MetaDeprecationModal({
  campaignType,
  onCancel,
  onConfirm,
  opened,
}: Readonly<IMetaDeprecationModalProps>): JSX.Element {
  const { t } = useTranslation();

  const campaignLabel = CampaignLabelMap.get(campaignType);

  return (
    <ConfirmModal
      alertDescription={t(
        'Pixl Plus provides the same ability to serve Meta ads, with more targeting controls and the option to include Display ads.',
      )}
      alertTitle={t("Your existing campaigns won't be affected")}
      alertType={'recommendation'}
      cancelButtonText={t('Cancel')}
      confirmButtonText={t('Create Pixl Plus campaign')}
      description={t('Pixl Plus is the new and better way to reach your Meta audiences.')}
      onClose={onCancel}
      onConfirm={onConfirm}
      opened={opened}
      t={t}
      title={t('{{campaignLabel}} is now part of Pixl Plus', { campaignLabel })}
    />
  );
}

export default MetaDeprecationModal;
